{
  "version": 1,
  "asset_id": "93075898-cdb2-41b7-9529-b44e774e3d7e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/93075898-cdb2-41b7-9529-b44e774e3d7e/hernando-galvalume-metal-roof-destination-roofing-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/93075898-cdb2-41b7-9529-b44e774e3d7e/hernando-galvalume-metal-roof-destination-roofing-1320w.avif",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-1320w.avif",
  "size": 109202,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
